import React from 'react';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';
import { FormSelect } from '@getro/rombo';
import { FormikAutoSubmit } from '../../../../components/atoms/formikAutoSubmit';
import { signUpDayOptions } from '../../../../components/organisms/contactsFilters/defaultFilters';

export const FirstSeenFilter = ({ value, setFilters }) => {
  const onSubmit = ({ firstSeen }) => {
    const firstSeenValue = firstSeen?.value || firstSeen || 'any';
    setFilters({ firstSeen: firstSeenValue });
  };

  const selectedValue = signUpDayOptions.find((opt) => opt.value === value) || signUpDayOptions[0];

  return (
    <Formik initialValues={{ firstSeen: selectedValue }} onSubmit={onSubmit} enableReinitialize>
      <Form>
        <FormikAutoSubmit />
        <Field
          name="firstSeen"
          label="First seen"
          placeholder="Any"
          component={FormSelect}
          options={signUpDayOptions}
          size="small"
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

FirstSeenFilter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setFilters: PropTypes.func.isRequired,
};

FirstSeenFilter.defaultProps = {
  value: 'any',
};
